import { createSelector } from '@reduxjs/toolkit';

import { ILayoutState, NotificationType } from './layoutState';

export const getToastNotifications = createSelector(
  (state: ILayoutState) => state.notifications,
  (notifications) => {
    return notifications.filter((n) => n.type === NotificationType.Toast);
  }
);
